import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GenericStore {
  isNavBarOpen: boolean;
}

const initialState: GenericStore = {
  isNavBarOpen: true,
};

const genericSlice = createSlice({
  name: 'generic',
  initialState,
  reducers: {
    setIsNavBarOpen: (state: GenericStore, action: PayloadAction<boolean>) => {
      state.isNavBarOpen = action.payload;
    },
  },
});

export const { setIsNavBarOpen } = genericSlice.actions;

export const genericReducer = genericSlice.reducer;
